import React from 'react';
import { checkAuth, userRole } from '../authenticationService';
import { Alert, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import Loader from './general/loader';


export default function Login(props) {
    const { history } = props;

    const [userName, setUserName] = React.useState('');
    const [password, setPassword] = React.useState('');

    const [error, setError] = React.useState({ message: "", duration: 6000, open: false, severity: "error" });
    const [loading, setLoading] = React.useState(false);

    const onSubmit = (e) => {
        e.preventDefault();
        if (!userName) {
            setError({ ...error, open: true, message: "Username is a required field." });
        }
        else if (!password) {
            setError({ ...error, open: true, message: "Password is a required field." });
        }
        else {
            setLoading(true);
            Promise.resolve(checkAuth(userName, password)).then((authenticated) => {

                if (authenticated === false) {
                    setError({ ...error, open: true, message: "Incorrect username and password combination." });
                    setLoading(false);
                    return;
                } else {
                    const role = userRole();
                    history.push({
                        pathname: '/Sangat',
                        state: role,
                    });
                    setLoading(false);
                }
            })
        }
    }

    return (
        <>
            <Loader open={loading} />
            <Grid container justifyContent="center" >
                <Grid centered item xs={12} md={4} >
                    <Paper variant="outlined">
                        <form onSubmit={onSubmit}>
                            <Stack p={2} spacing={2}>
                                <Stack spacing={1} direction="row" alignItems="flex-end" >
                                    <SelfImprovementIcon fontSize='large' sx={{ color: "#1976d2" }} />
                                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                        SIMS
                                    </Typography>
                                </Stack>
                                <TextField fullWidth required label="Username" value={userName} onChange={e => setUserName(e.target.value)} variant="outlined" />
                                <TextField fullWidth required label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} variant="outlined" />
                                {error.open && <Alert onClose={() => { setError({ ...error, open: false }) }} variant="filled" severity={error.severity} sx={{ width: '100%' }}>
                                    {error.message}
                                </Alert>
                                }
                                <Button disabled={loading} type="submit" variant="contained" size="large" onClick={onSubmit} onKeyUp={(event) => {
                                    if (event.key === "Enter") {
                                        onSubmit();
                                    }
                                }}>Login</Button>
                            </Stack>
                        </form>
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
}
